import React, {Component} from "react";
import moment from "moment";

class CalendarToolbar extends Component {

    // constructor(props) {
    //     super(props);
    //     console.log("CalendarToolbar.constructor(): props.viewState=", props.viewSate, ", props.view=", props.view)
    // }

    state = {
        viewState: this.props.viewState
    };

    onRefresh = () => {
        const {viewState} = this.state;
        const {date} = this.props;
        this.props.handleRefresh(date, viewState, true)
    };

    goToDayView = () => {
        this.props.onView("day");
        this.setState({viewState: "day"});
        this.props.handleDate(this.props.date, "day")
    };
    goToDayViewPerLoadingPlace = () => {
        this.props.onView("day");
        this.setState({viewState: "dayPerLoadingPlace"});
        this.props.handleDate(this.props.date, "dayPerLoadingPlace")
    };
    goToDayViewWithOccupancyPerLoadingPlace = () => {
        this.props.onView("day");
        this.setState({viewState: "dayWithOccupancyPerLoadingPlace"});
        this.props.handleDate(this.props.date, "dayWithOccupancyPerLoadingPlace")
    };
    goToWeekView = () => {
        const {date} = this.props;
        this.props.onView("week");

        const newDate = this.getStartOfWeek(date);
        this.props.onNavigate("next", newDate);

        this.setState({viewState: "week"});
        this.props.handleDate(this.props.date, "week")
    };
    goToMonthView = () => {
        this.props.onView("month");
        this.setState({viewState: "month"});
        this.props.handleDate(this.props.date, "month")
    };
    goToAgendaView = () => {
        this.props.onView("agenda");
        this.setState({viewState: "agenda"});
        this.props.handleDate(this.props.date, "agenda")
    };

    goToToday = () => {
        const {viewState} = this.state;

        const now = new Date();
        const newDate = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate()
        );
        this.props.onNavigate("current", newDate);
        this.props.handleDate(newDate, viewState)
    };

    goToPreviousDay = () => {
        const {viewState} = this.state;

        const {date} = this.props;
        const newDate = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate() - 1
        );
        this.props.onNavigate("prev", newDate);
        this.props.handleDate(newDate, viewState)
    };
    goToNextDay = () => {
        const {viewState} = this.state;

        const {date} = this.props;
        const newDate = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate() + 1
        );
        this.props.onNavigate("next", newDate);
        this.props.handleDate(newDate, viewState)
    };

    goToPreviousWeek = () => {
        const {viewState} = this.state;

        const {date} = this.props;
        const newDate = this.getStartOfWeek(
            new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate() - 7
            )
        );
        this.props.onNavigate("prev", newDate);
        this.props.handleDate(newDate, viewState)
    };
    goToNextWeek = () => {
        const {viewState} = this.state;

        const {date} = this.props;
        const newDate = this.getStartOfWeek(
            new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate() + 7
            )
        );
        this.props.onNavigate("next", newDate);
        this.props.handleDate(newDate, viewState)
    };
    getStartOfWeek = (date) => {
        while (date.getDay() !== 1) {
            date = new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate() - 1
            );
        }
        return date;
    }

    goToPreviousMonth = () => {
        const {viewState} = this.state;

        const {date} = this.props;
        const newDate = new Date(
            date.getFullYear(),
            date.getMonth() - 1,
            1
        );
        this.props.onNavigate("prev", newDate);
        this.props.handleDate(newDate, viewState)
    };
    goToNextMonth = () => {
        const {viewState} = this.state;

        const {date} = this.props;
        const newDate = new Date(
            date.getFullYear(),
            date.getMonth() + 1,
            1
        );
        this.props.onNavigate("next", newDate);
        this.props.handleDate(newDate, viewState)
    };

    goToPreviousYear = () => {
        const {viewState} = this.state;

        const {date} = this.props;
        const newDate = new Date(
            date.getFullYear() - 1,
            1,
            1
        );
        this.props.onNavigate("prev", newDate);
        this.props.handleDate(newDate, viewState)
    };
    goToNextYear = () => {
        const {viewState} = this.state;

        const {date} = this.props;
        const newDate = new Date(
            date.getFullYear() + 1,
            1,
            1
        );
        this.props.onNavigate("next", newDate);
        this.props.handleDate(newDate, viewState)
    };

    onSearchCompany = ({currentTarget: input}) => {
        const {viewState} = this.state;
        const {date, handleSearchCompany} = this.props;

        handleSearchCompany(viewState, date, input.value)
    }

    render = () => {

        const {
            date, companyList, searchedCompany, name,
            handleEditAccount,
            handleCreateReceiver, handleInviteReceiver,
            handleCreateVendor, handleInviteVendor,
            handleCreateCarrier, handleInviteCarrier
        } = this.props;
        const {
            createReceiver, inviteReceiver,
            createVendor, inviteVendor,
            createCarrier, inviteCarrier
        } = this.props.rolesMap;
        const {viewState} = this.state;

        const momentDate = moment(date);

        const now = new Date();
        const today = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate()
        );
        const calendarToday = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate()
        );

        return (
            <div className="rbc-toolbar">
                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                    <a className="navbar-brand" href="#">{name}</a>
                    <button className="navbar-toggler" type="button" data-toggle="collapse"
                            data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false"
                            aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNavDropdown">
                        <ul className="navbar-nav">
                            <li className="nav-item active">
                                <a className="nav-link" href="#" onClick={this.onRefresh}>Aktualisieren</a>
                            </li>
                            <li className="nav-item dropdown active">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownPresentation"
                                   role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Darstellung
                                </a>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdownPresentation">
                                    <a className={"dropdown-item" + (viewState === "day" ? ' active' : "")} href="#"
                                       onClick={this.goToDayView}>
                                        Tagesansicht
                                    </a>
                                    <a className={"dropdown-item" + (viewState === "dayPerLoadingPlace" ? ' active' : "")}
                                       href="#"
                                       onClick={this.goToDayViewPerLoadingPlace}>
                                        Tagansicht per Umschlagplatz
                                    </a>
                                    {/*<a className={"dropdown-item" + (viewState === "dayWithOccupancyPerLoadingPlace" ? ' active' : "")}*/}
                                    {/*   href="#"*/}
                                    {/*   onClick={this.goToDayViewWithOccupancyPerLoadingPlace}>*/}
                                    {/*    Tagansicht mit Belegung per Umschlagplatz*/}
                                    {/*</a>*/}
                                    <a className={"dropdown-item" + (viewState === "week" ? ' active' : "")} href="#"
                                       onClick={this.goToWeekView}>
                                        Wochenansicht
                                    </a>
                                    <a className={"dropdown-item" + (viewState === "month" ? ' active' : "")} href="#"
                                       onClick={this.goToMonthView}>
                                        Monatsansicht
                                    </a>
                                    {/*<a className={"dropdown-item" + (viewState === "agenda" ? ' active' : "")} href="#"*/}
                                    {/*   onClick={this.goToAgendaView}>*/}
                                    {/*    Agenda*/}
                                    {/*</a>*/}
                                </div>
                            </li>
                            <li className="nav-item dropdown active">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMaintenance"
                                   role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Stammdaten
                                </a>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdownMaintenance">
                                    <a className="dropdown-item" href="#"
                                       onClick={handleEditAccount}>
                                        Konto verwalten
                                    </a>
                                    {createReceiver && (
                                        <a className="dropdown-item" href="#"
                                           onClick={handleCreateReceiver}>
                                            Empfänger anlegen
                                        </a>
                                    )}
                                    {inviteReceiver && (
                                        <a className="dropdown-item" href="#"
                                           onClick={handleInviteReceiver}>
                                            bestehenden Empfänger einladen
                                        </a>
                                    )}
                                    {createVendor && (
                                        <a className="dropdown-item" href="#"
                                           onClick={handleCreateVendor}>
                                            Lieferanten anlegen
                                        </a>
                                    )}
                                    {inviteVendor && (
                                        <a className="dropdown-item" href="#"
                                           onClick={handleInviteVendor}>
                                            bestehenden Lieferanten einladen
                                        </a>
                                    )}
                                    {createCarrier && (
                                        <a className="dropdown-item" href="#"
                                           onClick={handleCreateCarrier}>
                                            Spediteur anlegen
                                        </a>
                                    )}
                                    {inviteCarrier && (
                                        <a className="dropdown-item" href="#"
                                           onClick={handleInviteCarrier}>
                                            bestehenden Spediteur einladen
                                        </a>
                                    )}
                                </div>
                            </li>
                            {viewState === "month" && (
                                <li className="nav-item active" onClick={this.goToPreviousYear}>
                                    <a className="nav-link" href="#"><span
                                        className="prev-icon">&#8249;&#8249;</span></a>
                                </li>
                            )}
                            {(viewState === "day" || viewState === "dayPerLoadingPlace" || viewState === "dayWithOccupancyPerLoadingPlace") && (
                                <li className="nav-item active" onClick={this.goToPreviousDay}>
                                    <a className="nav-link" href="#"><span className="prev-icon">&#8249;</span></a>
                                </li>
                            )}
                            {(viewState === "week" || viewState === "agenda") && (
                                <li className="nav-item active" onClick={this.goToPreviousWeek}>
                                    <a className="nav-link" href="#"><span className="prev-icon">&#8249;</span></a>
                                </li>
                            )}
                            {viewState === "month" && (
                                <li className="nav-item active" onClick={this.goToPreviousMonth}>
                                    <a className="nav-link" href="#"><span className="prev-icon">&#8249;</span></a>
                                </li>
                            )}

                            {(viewState === "day" || viewState === "dayPerLoadingPlace" || viewState === "dayWithOccupancyPerLoadingPlace") && (
                                <a className="nav-link" href="#"><span
                                    className="rbc-toolbar-label">{momentDate.format("ddd DD.MM.YYYY")}</span></a>
                            )}
                            {(viewState === "week" || viewState === "agenda") && (
                                <a className="nav-link" href="#"><span
                                    className="rbc-toolbar-label">{momentDate.format("DD.MM.YYYY")} - {momentDate.add(6, "days").format("DD.MM.YYYY")}</span></a>
                            )}
                            {viewState === "month" && (
                                <a className="nav-link" href="#"><span
                                    className="rbc-toolbar-label">{momentDate.format("MMMM YYYY")}</span></a>
                            )}

                            {(viewState === "day" || viewState === "dayPerLoadingPlace" || viewState === "dayWithOccupancyPerLoadingPlace") && (
                                <li className="nav-item active" onClick={this.goToNextDay}>
                                    <a className="nav-link" href="#"><span className="prev-icon">&#8250;</span></a>
                                </li>
                            )}
                            {(viewState === "week" || viewState === "agenda") && (
                                <li className="nav-item active" onClick={this.goToNextWeek}>
                                    <a className="nav-link" href="#"><span className="prev-icon">&#8250;</span></a>
                                </li>
                            )}
                            {viewState === "month" && (
                                <li className="nav-item active" onClick={this.goToNextMonth}>
                                    <a className="nav-link" href="#"><span className="prev-icon">&#8250;</span></a>
                                </li>
                            )}
                            {viewState === "month" && (
                                <li className="nav-item active" onClick={this.goToNextYear}>
                                    <a className="nav-link" href="#"><span
                                        className="prev-icon">&#8250;&#8250;</span></a>
                                </li>
                            )}
                            {today.getTime() !== calendarToday.getTime() && (viewState === "day" || viewState === "dayPerLoadingPlace" || viewState === "dayWithOccupancyPerLoadingPlace") && (
                                <li className="nav-item active">
                                    <a className="nav-link" href="#" onClick={this.goToToday}>Heute</a>
                                </li>
                            )}
                        </ul>
                    </div>
                </nav>

                {/*damit die Toolbar ganz links angezeigt wird*/}
                <span className="rbc-toolbar-label"></span>

                {/*<span className="rbc-btn-group">*/}
                {/*    {renderSelectByList(*/}
                {/*        {*/}
                {/*            name: "receiver.company",*/}
                {/*            itemsMap: {},*/}
                {/*            itemList: companyList,*/}
                {/*            // "nullable": "false",*/}
                {/*            // handleItemSelect: handleSearchCompany*/}
                {/*        },*/}
                {/*        searchedCompany,*/}
                {/*        {},*/}
                {/*        this.onSearchCompany)*/}
                {/*    }*/}
                {/*</span>*/}

            </div>
        );
    }

}

export default CalendarToolbar;
